module.exports = __webpack_public_path__ + "img/ctrl-pauli-y-root-dagger-1.5ecbfd37.svg";